import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance90 = () => {
  return <IndividualTable matchType={"PRE"} gender="M" event="90" subTitle="TarscaShild" data={sampleData} topRankCount="16" />;
};
export default Distance90;
